(function () {
  'use strict';

  /* @ngdoc object
   * @name individualFlyingHours
   * @description
   *
   */
  angular
    .module('individualFlyingHours', [
      'ui.router'
    ]);
}());
